import classes from "./ComplianceStandard.module.scss";
import { Trans, useTranslation } from "react-i18next";

const ComplianceStandard = () => {
  const { t } = useTranslation("complianceStandard");

  const cardsData = [
    {
      id: "iso9001",
      title: "ISO 9001",
      text: t("iso9001"),
    },
    {
      id: "iso14001",
      title: "ISO 14001",
      text: t("iso14001"),
    },
    {
      id: "iso45001",
      title: "ISO 45001",
      text: t("iso45001"),
    },
    {
      id: "UNI/PdR125",
      title: "UNI/PdR 125",
      text: t("UNI/PdR125"),
    },
  ];

  return (
    <div className={classes.container}>
      <h3 className="grayMediumDark">{t("title")}</h3>
      <div className={classes.content}>
        <div className={classes.textContainer}>
          <p className="grayMedium">{t("text1")}</p>
          <p className="grayMedium">
            <Trans
              ns="complianceStandard"
              i18nKey="text2"
              components={{ b: <b /> }}
            />
          </p>
        </div>
        <div className={classes.cards}>
          {cardsData.map((card) => (
            <div key={card.id} className={classes.card}>
              <h5 className={`${classes.title} grayMedium `}>{card.title}</h5>
              <div className={classes.textLine}>
                <p className={`${classes.text} grayMedium `}>{card.text}</p>
                <div className={classes.separator}></div>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.textContainer}>
          <p className="grayMedium">
            <Trans
              ns="complianceStandard"
              i18nKey="text3"
              components={{ b: <b /> }}
            />
          </p>
          <p className="grayMedium">{t("text4")}</p>
        </div>
        <a
          className={classes.button}
          href="/documents/politicaIntegrata20250512.pdf"
          target="_blank"
        >
          {t("button")}
        </a>
      </div>
    </div>
  );
};

export default ComplianceStandard;
